import Box, { type BoxProps } from '@mui/material/Box';

export function SearchListboxContainer({ children, ...props }: BoxProps) {
  return (
    <Box
      component="ul"
      role="listbox"
      sx={{
        p: 0,
        my: 0,
        '&, & ul': {
          listStyle: 'none',
          px: 0,
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
